<template>
  <div class="checkbox-container" :style="customStyle" @click="onSelect(title)">
    <div
      class="checkbox"
      :class="{
        'checkbox selected': checked
      }"
    >
      <img v-if="checked" src="@/assets/images/check_1.png" class="checkbox-img" />
    </div>
    <div
      class="checkbox-title"
      :class="{
        'checkbox-title selected': checked
      }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    title: String,
    customStyle: String,
    onSelect: Function,
    checked: Boolean
  }
};
</script>

<style scoped lang="scss">
.checkbox-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  .checkbox {
    width: 15px;
    height: 15px;
    border: 1px solid #c2c7cf;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &.selected {
      border: none;
      background-color: $colorGreen;
    }

    .checkbox-img {
      width: 18px;
      height: 16px;
      margin-top: 3px;
    }
  }

  .checkbox-title {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: #c2c7cf;
    margin-left: 10px;

    &.selected {
      color: $colorText;
    }
  }
}
</style>
